// Particle Colors (sRGB)
export const COLOR_GOLD_RGB = { r: 0.973, g: 0.741, b: 0.141 }; // #f8bd24
export const COLOR_METALLIC_BLUE_RGB = { r: 0.282, g: 0.663, b: 0.902 }; // #48a9e6
